import { render, staticRenderFns } from "./CommentCourse.vue?vue&type=template&id=09f36738&scoped=true&"
import script from "./CommentCourse.vue?vue&type=script&lang=js&"
export * from "./CommentCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f36738",
  null
  
)

export default component.exports